import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy, HeaderTwo } from 'secondstep-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  background-color: ${themeGet('colors.white')};
  padding: 1.25rem;
  border-radius: 0.75rem;
  height: auto;

  ${themeGet('breakpoints.medium')} {
    width: auto;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 2px solid ${themeGet('colors.paleGray')};
  padding-bottom: 1.313rem;
  width: 100%;
`

export const HeaderTitle = styled(HeaderTwo)`
  margin: 0;
  margin-bottom: -0.438rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};
`

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  margin-top: 1.25rem;
  gap: 1.25rem;
  min-width: 0;
`

export const ContentImage = styled.img`
  width: 265px;
  height: 194px;
  display: block;
`

export const Body = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: auto;
`

export const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: 1.75rem;
`

export const ReadCopy = styled(BodyCopy)`
  color: ${themeGet('colors.darkGray')};
  text-align: start;
  margin-top: 1.25rem;

  a {
    color: ${themeGet('colors.blue')};
  }
`
